import Vue from 'vue'
import Router from 'vue-router'
// import home from '@/components/home/home'
import menu from '@/components/Menu/menu'

const login = () => import( /* webpackChunkName: "Login" */ '@/components/Login/login')
const register = () => import( /* webpackChunkName: "Login" */ '@/components/Login/register')
const reset = () => import( /* webpackChunkName: "Login" */ '@/components/Login/reset')
const aboutYou = () => import( /* webpackChunkName: "Login" */ '@/components/Login/AboutYou')

const deposit = () => import( /* webpackChunkName: "AccountPost" */ '@/components/AccountPost/deposit')
const withdraw = () => import( /* webpackChunkName: "AccountPost" */ '@/components/AccountPost/withdraw')

const dowpla = () => import( /* webpackChunkName: "Trading" */ '@/components/Trading/DowPla')
const spec = () => import( /* webpackChunkName: "Trading" */ '@/components/Trading/spec')
const overnight = () => import( /* webpackChunkName: "Trading" */ '@/components/Trading/overnight')

const glossary = () => import( /* webpackChunkName: "Education" */ '@/components/Education/glossary')
const videos = () => import( /* webpackChunkName: "Education" */ '@/components/Education/videos')

const license = () => import( /* webpackChunkName: "Regulatory" */ '@/components/Regulatory/License')
const legal = () => import( /* webpackChunkName: "Regulatory" */ '@/components/Regulatory/Legal')

const generic = () => import( /* webpackChunkName: "FAQ" */ '@/components/FAQ/generic')
const taq = () => import( /* webpackChunkName: "FAQ" */ '@/components/FAQ/taq')
const dw = () => import( /* webpackChunkName: "FAQ" */ '@/components/FAQ/dw')
const gtq = () => import( /* webpackChunkName: "FAQ" */ '@/components/FAQ/gtq')

const about = () => import( /* webpackChunkName: "AboutUS" */ '@/components/AboutUS/about')
const contact = () => import( /* webpackChunkName: "AboutUS" */ '@/components/AboutUS/contact')

const Abyou = () => import( /* webpackChunkName: "ABinfo" */ '@/components/ABinfo/Abyou')
const EconomicP = () => import( /* webpackChunkName: "ABinfo" */ '@/components/ABinfo/EconomicP')
const TradingE = () => import( /* webpackChunkName: "ABinfo" */ '@/components/ABinfo/TradingE')

import language from '@/components/Language/lang'
import {
  Indicator
} from 'mint-ui';
let spinRoute = {
  show() {
    Indicator.open({
      spinnerType: 'fading-circle'
    });
  },
  resolve(resolve) {
    return component => {
      setTimeout(() => {
        Indicator.close()
        resolve(component);
      }, 10)
    }
  }
}

// import test from '@/components/Education/test'
import chat from '@/components/Chat/chat'
Vue.use(Router)
let routes = [{
    //重定向
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: function (resolve) {
      spinRoute.show();
      require(['@/components/home/home'], spinRoute.resolve(resolve));
    }
  },
  {
    path: '/menu',
    name: 'menu',
    component: menu
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/register',
    name: 'register',
    component: register
  },
  {
    path: '/aboutYou',
    name: 'aboutYou',
    component: aboutYou,
    children: [{
        path: '/Abyou',
        name: 'Abyou',
        component: Abyou,
      },
      {
        path: '/EconomicP',
        name: 'EconomicP',
        component: EconomicP,
      },
      {
        path: '/TradingE',
        name: 'TradingE',
        component: TradingE,
      }
    ],
    redirect: '/Abyou'
  },
  {
    path: '/reset',
    name: 'reset',
    component: reset
  },
  {
    path: '/deposit',
    name: 'deposit',
    component: deposit
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    component: withdraw
  },
  {
    path: '/dowpla',
    name: 'dowpla',
    component: dowpla
  },
  {
    path: '/spec',
    name: 'spec',
    component: spec
  },
  {
    path: '/overnight',
    name: 'overnight',
    component: overnight
  },
  {
    path: '/glossary',
    name: 'glossary',
    component: glossary
  },
  {
    path: '/videos',
    name: 'videos',
    component: videos
  },
  {
    path: '/license',
    name: 'license',
    component: license
  },
  {
    path: '/legal',
    name: 'legal',
    component: legal
  },
  {
    path: '/generic',
    name: 'generic',
    component: generic
  },
  {
    path: '/taq',
    name: 'taq',
    component: taq
  },
  {
    path: '/dw',
    name: 'dw',
    component: dw
  },
  {
    path: '/gtq',
    name: 'gtq',
    component: gtq
  },
  {
    path: '/about',
    name: 'about',
    component: about
  },
  {
    path: '/contact',
    name: 'contact',
    component: contact
  },
  {
    path: '/language',
    name: 'language',
    component: language
  },
  {
    path: '/chat',
    name: 'chat',
    component: chat
  },
]
const router = new Router({
  // mode:"history",
  routes
})
export default router



//////////////////
// WEBPACK FOOTER
// ./src/router/index.js
// module id = null
// module chunks = 